export type Gender = 0 | 1 | 2;

export const Gender = {
  unespecified: 0 as const,
  male: 1 as const,
  female: 2 as const,
};

export default Gender;
